document.addEventListener('DOMContentLoaded', function() {
        jQuery('.tarifroom-toggle button').click(function(){
                var showclass = this.dataset.value;
                jQuery(this).parent('.togglebutton_wrap').find('button').removeClass('t-active');
                  jQuery(this).addClass('t-active');
console.log(showclass);
                jQuery('.room-tarife .tarif-item .room_price').removeClass('showprice');
                jQuery('.room-tarife .tarif-item .room_price.'+showclass).addClass('showprice');
            });


        jQuery('#roomplan-toggle button').click(function(){
                var showclass = this.dataset.value;
                jQuery(this).parent('.togglebutton_wrap').find('button').removeClass('t-active');
                  jQuery(this).addClass('t-active');
                console.log(showclass);
                jQuery('.raumaufteilung-wrapper img').removeClass('show');
                jQuery('.raumaufteilung-wrapper img#'+showclass).addClass('show');
            });
});
